/* Art & Living – één klein script, geen dependencies. Geladen met defer. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const mqDesktop = matchMedia('(min-width: 990px)');
  const mqTablet = matchMedia('(min-width: 750px)');

  /* ---------- drawers (menu, filter, cart) ---------- */
  let lastFocus = null;
  const openDrawer = (drawer) => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('button, a, input, select', drawer.querySelector('.drawer__panel'));
    setTimeout(() => focusable && focusable.focus(), 50);
  };
  const closeDrawer = (drawer) => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer($('#cart-drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('details[data-close-outside][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- header: vast wit na scroll, menu/zoek-panelen ---------- */
  const header = $('[data-header]');
  if (header && header.classList.contains('header-wrapper--overlay')) {
    const onScroll = () => header.classList.toggle('is-solid', scrollY > 10);
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  const panels = $$('details[data-close-outside]');
  panels.forEach((d) => {
    d.addEventListener('toggle', () => { if (d.open) panels.forEach((o) => o !== d && o.removeAttribute('open')); if (d.open) { const i = $('input[type=search]', d); if (i) i.focus(); } });
    if (d.hasAttribute('data-mega')) {
      let t;
      d.addEventListener('mouseenter', () => { if (!mqDesktop.matches) return; clearTimeout(t); d.open = true; });
      d.addEventListener('mouseleave', () => { if (!mqDesktop.matches) return; t = setTimeout(() => d.removeAttribute('open'), 150); });
    }
  });
  document.addEventListener('click', (e) => panels.forEach((d) => { if (d.open && !d.contains(e.target)) d.removeAttribute('open'); }));

  /* mobiel menu: submenu's met Terug */
  const mnav = $('[data-mnav]');
  if (mnav) {
    mnav.addEventListener('click', (e) => {
      const open = e.target.closest('[data-mnav-open]');
      if (open) {
        const level = document.getElementById(open.dataset.mnavOpen);
        level.classList.add('is-active'); level.setAttribute('aria-hidden', 'false'); open.setAttribute('aria-expanded', 'true');
        const back = $('[data-mnav-back]', level); if (back) back.focus();
      }
      const back = e.target.closest('[data-mnav-back]');
      if (back) {
        const level = back.closest('[data-mnav-level]');
        level.classList.remove('is-active'); level.setAttribute('aria-hidden', 'true');
        const btn = $(`[data-mnav-open="${level.id}"]`, mnav); if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
      }
    });
  }

  /* ---------- footer: kolommen open op tablet/desktop ---------- */
  const footerCols = $$('[data-footer-col]');
  const syncFooter = () => footerCols.forEach((d) => { d.open = mqTablet.matches; });
  syncFooter(); mqTablet.addEventListener('change', syncFooter);

  /* ---------- productslider met teller ---------- */
  const initSlider = (root) => {
    const track = $('[data-slider-track]', root);
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
    const counters = $$('[data-slider-current]', root);
    const step = () => { const item = track.children[0]; return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
    const update = () => {
      const i = Math.round(track.scrollLeft / step());
      counters.forEach((c) => { c.textContent = Math.min(i + 1, track.children.length); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    addEventListener('resize', update);
    update();
  };
  $$('[data-slider]').forEach(initSlider);

  /* ---------- slideshow ---------- */
  $$('[data-slideshow]').forEach((root) => {
    const track = $('[data-slideshow-track]', root);
    const dots = $$('[data-slideshow-dot]', root);
    const go = (i) => { const n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth }); };
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    track.addEventListener('scroll', () => requestAnimationFrame(() => { const c = current(); dots.forEach((d, i) => d.setAttribute('aria-current', String(i === c))); }), { passive: true });
    dots.forEach((d) => d.addEventListener('click', () => go(+d.dataset.slideshowDot)));
    const p = $('[data-slideshow-prev]', root), n = $('[data-slideshow-next]', root);
    p && p.addEventListener('click', () => go(current() - 1));
    n && n.addEventListener('click', () => go(current() + 1));
  });

  /* ---------- productgalerij: hoofdfoto (swipe) + thumbnails ---------- */
  const galleryGo = (root, i) => {
    const track = $('[data-gallery-track]', root);
    if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  };
  $$('[data-gallery]').forEach((root) => {
    const track = $('[data-gallery-track]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const mark = () => {
      const c = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === c)));
      const active = thumbs[c];
      const list = $('.gallery__thumbs', root);
      if (active && list) {
        const li = active.parentElement;
        list.scrollTo({ left: li.offsetLeft - (list.clientWidth - li.clientWidth) / 2, top: li.offsetTop - (list.clientHeight - li.clientHeight) / 2, behavior: 'smooth' });
      }
    };
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => galleryGo(root, +t.dataset.galleryThumb)));
  });

  /* ---------- lightbox: groot bekijken + inzoomen ---------- */
  $$('[data-lightbox]').forEach((lb) => {
    const gallery = lb.closest('[data-gallery]');
    const items = $$('[data-zoom]', gallery);
    const img = $('[data-lightbox-img]', lb);
    const stage = $('[data-lightbox-stage]', lb);
    const count = $('[data-lightbox-count]', lb);
    let index = 0;
    document.body.appendChild(lb);
    const show = (i) => {
      index = (i + items.length) % items.length;
      lb.classList.remove('is-zoomed');
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = items[index].dataset.zoom;
      img.alt = items[index].dataset.zoomAlt || '';
      if (count) count.textContent = `${index + 1} / ${items.length}`;
    };
    const zoomAt = (x, y) => {
      const r = img.getBoundingClientRect();
      const fx = (x - r.left) / r.width, fy = (y - r.top) / r.height;
      lb.classList.add('is-zoomed');
      requestAnimationFrame(() => {
        stage.scrollLeft = fx * stage.scrollWidth - stage.clientWidth / 2;
        stage.scrollTop = fy * stage.scrollHeight - stage.clientHeight / 2;
      });
    };
    gallery.addEventListener('click', (e) => {
      const b = e.target.closest('[data-zoom-open]');
      if (!b) return;
      show(+b.dataset.zoomOpen);
      openDrawer(lb);
    });
    img.addEventListener('click', (e) => {
      if (lb.classList.contains('is-zoomed')) lb.classList.remove('is-zoomed');
      else zoomAt(e.clientX, e.clientY);
    });
    // muis: pannen door te bewegen als ingezoomd
    stage.addEventListener('mousemove', (e) => {
      if (!lb.classList.contains('is-zoomed') || !matchMedia('(pointer: fine)').matches) return;
      stage.scrollLeft = (e.clientX / stage.clientWidth) * (stage.scrollWidth - stage.clientWidth);
      stage.scrollTop = (e.clientY / stage.clientHeight) * (stage.scrollHeight - stage.clientHeight);
    });
    const prev = $('[data-lightbox-prev]', lb), next = $('[data-lightbox-next]', lb);
    prev && prev.addEventListener('click', () => show(index - 1));
    next && next.addEventListener('click', () => show(index + 1));
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
    // swipe tussen foto's (alleen als niet ingezoomd)
    let sx = null;
    stage.addEventListener('touchstart', (e) => { sx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (sx === null || lb.classList.contains('is-zoomed') || items.length < 2) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) show(index + (dx < 0 ? 1 : -1));
      sx = null;
    }, { passive: true });
  });

  /* ---------- geld ---------- */
  const money = (cents) => {
    const fmt = (window.theme && theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const v = (cents / 100).toFixed(2);
    const [i, d] = v.split('.');
    const withDots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals_with_comma_separator') return withDots;
      if (k === 'amount_with_comma_separator') return `${withDots},${d}`;
      if (k === 'amount_no_decimals') return i.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${i.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${d}`;
    });
  };

  /* ---------- winkelwagen ---------- */
  const cartDrawer = $('#cart-drawer');
  const refreshCart = (sections) => {
    const html = sections && sections['cart-drawer'];
    if (!html || !cartDrawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('.drawer__panel', doc);
    if (fresh) $('.drawer__panel', cartDrawer).innerHTML = fresh.innerHTML;
  };
  const setCount = (count) => $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
  const cartChange = async (line, quantity) => {
    const body = $('[data-cart-body]', cartDrawer);
    body && body.classList.add('is-loading');
    const res = await fetch(`${theme.routes.cartChange}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: Math.max(0, quantity), sections: ['cart-drawer'] }),
    });
    const data = await res.json();
    refreshCart(data.sections);
    if (typeof data.item_count === 'number') setCount(data.item_count);
  };
  if (cartDrawer) {
    cartDrawer.addEventListener('click', (e) => {
      const b = e.target.closest('[data-cart-qty]');
      if (b) cartChange(+b.dataset.cartQty, +b.dataset.qty);
    });
    cartDrawer.addEventListener('change', (e) => {
      const i = e.target.closest('[data-cart-input]');
      if (i) cartChange(+i.dataset.cartInput, +i.value);
    });
  }

  /* ---------- productpagina ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    const form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;
    const { variants } = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtns = $$('[data-add-button]', root);
    const priceEl = $('[data-price]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const errorEl = $('[data-form-error]', root);
    const selects = $$('[data-option-select]', form);

    const selected = () => selects.map((sel) => sel.value);
    const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const markAvailability = (opts) => {
      selects.forEach((sel, idx) => {
        [...sel.options].forEach((o) => {
          const test = [...opts]; test[idx] = o.value;
          const v = findVariant(test);
          o.textContent = o.value + (!v || !v.available ? ' – uitverkocht' : '');
        });
      });
    };
    const render = (v) => {
      if (!v) {
        addBtns.forEach((b) => { b.disabled = true; b.textContent = 'Niet beschikbaar'; });
        return;
      }
      idInput.value = v.id;
      const sale = v.compare_at_price && v.compare_at_price > v.price;
      priceEl.classList.toggle('price--sale', !!sale);
      priceEl.innerHTML = `<span class="price__current">${money(v.price)}</span>${sale ? `<s class="price__compare">${money(v.compare_at_price)}</s>` : ''}`;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      addBtns.forEach((b) => { b.disabled = !v.available; b.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht'; });
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_media) {
        const item = $(`[data-media-id="${v.featured_media.id}"]`, root);
        const gallery = $('[data-gallery]', root);
        if (item && gallery) galleryGo(gallery, +item.dataset.index);
      }
    };
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-select]')) return;
      const opts = selected();
      markAvailability(opts);
      render(findVariant(opts));
    });
    if (selects.length) markAvailability(selected());

    /* lijst-venster met swatches */
    $$('[data-frame-modal]', root).forEach((modal) => {
      const idx = +modal.dataset.optionIndex;
      const sel = selects.find((x) => +x.dataset.optionIndex === idx);
      const trigger = $(`[aria-controls="${modal.id}"]`, root);
      const current = trigger && $('[data-frame-current]', trigger);
      let triggerSwatch = trigger && $('[data-frame-swatch]', trigger);
      document.body.appendChild(modal);
      const prices = () => $$('[data-frame-value]', modal).forEach((row) => {
        const test = selected(); test[idx] = row.dataset.frameValue;
        const v = findVariant(test);
        $('[data-frame-price]', row).textContent = v ? (v.available ? money(v.price) : 'Uitverkocht') : '';
      });
      prices();
      form.addEventListener('change', prices);
      modal.addEventListener('click', (e) => {
        const row = e.target.closest('[data-frame-value]');
        if (!row || !sel) return;
        sel.value = row.dataset.frameValue;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        $$('[data-frame-value]', modal).forEach((r) => r.setAttribute('aria-pressed', String(r === row)));
        if (current) current.textContent = row.dataset.frameLabel || row.dataset.frameValue;
        const sw = $('[data-frame-swatch]', row);
        if (triggerSwatch && sw) {
          const copy = sw.cloneNode(true);
          copy.classList.add(sw.dataset.smClass);
          triggerSwatch.replaceWith(copy);
          triggerSwatch = copy;
        }
        closeDrawer(modal);
      });
    });

    /* in winkelwagen via AJAX, daarna drawer open */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      addBtns.forEach((b) => b.classList.add('is-loading'));
      try {
        const fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', location.pathname);
        const res = await fetch(`${theme.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Toevoegen is niet gelukt.');
        refreshCart(data.sections);
        const cart = await (await fetch(`${theme.routes.cart}.js`)).json();
        setCount(cart.item_count);
        openDrawer(cartDrawer);
      } catch (err) {
        errorEl.textContent = err.message; errorEl.hidden = false;
      } finally {
        addBtns.forEach((b) => b.classList.remove('is-loading'));
      }
    });

    /* sticky balk op mobiel */
    const sticky = $('[data-sticky-atc]', root);
    const mainBtn = $('[data-add-button]', form);
    if (sticky && mainBtn) {
      let ticking = false;
      const check = () => {
        ticking = false;
        const show = mainBtn.getBoundingClientRect().bottom < 0;
        if (show === sticky.classList.contains('is-visible')) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $('button', sticky).tabIndex = show ? 0 : -1;
      };
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
    }
  });

  /* ---------- aanbevelingen ---------- */
  $$('[data-recommendations]').forEach((el) => {
    const load = async () => {
      try {
        const html = await (await fetch(el.dataset.recommendations)).text();
        const fresh = $('[data-recommendations]', new DOMParser().parseFromString(html, 'text/html'));
        if (!fresh) return;
        // huidig product nooit als aanbeveling tonen
        const own = el.dataset.productUrl;
        $$('.card__link', fresh).forEach((a) => { if (own && new URL(a.href, location.href).pathname === own) a.closest('li').remove(); });
        if (!$('.card__link', fresh)) return;
        el.innerHTML = fresh.innerHTML;
        el.hidden = false;
        $$('[data-slider]', el).forEach(initSlider);
      } catch (_) { /* placeholders blijven staan */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* ---------- filters + sorteren ---------- */
  const facetsForm = $('[data-facets-form]');
  if (facetsForm) {
    let t;
    facetsForm.addEventListener('change', (e) => {
      clearTimeout(t);
      t = setTimeout(() => facetsForm.requestSubmit ? facetsForm.requestSubmit() : facetsForm.submit(), e.target.type === 'number' ? 600 : 0);
    });
  }
  $$('[data-sort-select]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); location.href = url;
  }));
})();

/* Cookiebanner (Shopify Customer Privacy API) */
(() => {
  const box = document.querySelector('[data-cookie]');
  if (!box || !window.Shopify || !Shopify.loadFeatures) return;
  Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
    const cp = window.Shopify.customerPrivacy;
    if (err || !cp) return;
    const set = (yes) => cp.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, () => { box.hidden = true; });
    box.querySelector('[data-cookie-accept]').addEventListener('click', () => set(true));
    box.querySelector('[data-cookie-decline]').addEventListener('click', () => set(false));
    document.addEventListener('click', (e) => { if (e.target.closest('[data-cookie-settings]')) { e.preventDefault(); box.hidden = false; } });
    if (cp.shouldShowBanner()) box.hidden = false;
  });
})();

/* AR "Bekijk aan je muur": module pas laden na een klik */
(() => {
  const open = async (btn) => {
    const modal = document.getElementById(btn.getAttribute('aria-controls'));
    if (!modal) return;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    try { (await import(btn.dataset.arScript)).show(modal, btn); } catch (e) { console.error(e); }
  };
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-ar-open]'); if (b) open(b); });
  const auto = document.querySelector('[data-ar-open]');
  if (auto && new URLSearchParams(location.search).get('ar') === '1') open(auto);
})();

/* Verlanglijstje: bewaard in deze browser, deelbaar via een link */
(() => {
  const KEY = 'al-wishlist';
  const $$ = (q, r = document) => [...r.querySelectorAll(q)];
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };
  const sync = () => {
    const list = read();
    $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', String(list.includes(b.dataset.wish))));
    $$('[data-wish-count]').forEach((c) => { c.textContent = list.length; c.hidden = !list.length; });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    const h = b.dataset.wish;
    const list = read();
    write(list.includes(h) ? list.filter((x) => x !== h) : [h, ...list]);
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  });
  sync();

  const root = document.querySelector('[data-wishlist]');
  if (!root) return;
  const grid = root.querySelector('[data-wish-grid]');
  const shared = (new URLSearchParams(location.search).get('items') || '').split(',').filter(Boolean);
  const share = root.querySelector('[data-wish-share]');
  const status = root.querySelector('[data-wish-status]');
  if (shared.length) {
    root.querySelector('[data-wish-title]').textContent = 'Een verlanglijstje voor jou';
    root.querySelector('[data-wish-intro]').textContent = 'Iemand heeft deze schilderijen voor je uitgezocht. Tik op het hartje om ze ook op je eigen lijstje te zetten.';
  }
  const render = async () => {
    const list = shared.length ? shared : read();
    root.querySelector('[data-wish-empty]').hidden = list.length > 0;
    share.hidden = shared.length > 0 || list.length === 0;
    const cards = await Promise.all(list.map((h) => fetch(`/products/${encodeURIComponent(h)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    grid.innerHTML = cards.join('');
    sync();
  };
  render();
  if (!shared.length) document.addEventListener('wishlist:change', render);
  share.addEventListener('click', async () => {
    const url = `${location.origin}${location.pathname}?items=${read().map(encodeURIComponent).join(',')}`;
    try {
      if (navigator.share && matchMedia('(pointer: coarse)').matches) { await navigator.share({ title: 'Mijn verlanglijstje bij Art & Living', url }); return; }
      await navigator.clipboard.writeText(url);
      status.textContent = 'Link gekopieerd. Plak hem in een bericht aan wie je maar wilt.';
    } catch (e) { status.textContent = url; }
  });
})();

/* Cadeaukaart: velden voor de ontvanger aan/uit */
(() => {
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-gift-toggle]');
    if (!t) return;
    const fields = t.closest('[data-gift-recipient]').querySelector('[data-gift-fields]');
    fields.hidden = !t.checked;
    fields.querySelectorAll('input, textarea').forEach((f) => { f.disabled = !t.checked; });
  });
})();
